import {USER_RELOAD_PERMISSIONS} from '~/frontend/src/constants';
import {StoreState, AppDispatch, Thunk} from '~/frontend/src/store';
import xhr from '~/frontend/src/utilities/xhr';
import setUser from '~/frontend/src/actions/user/setUser';


export type ReloadPermissionsAction = {
    type : typeof USER_RELOAD_PERMISSIONS;
}

/**
 * @memberOf! Actions
 *
 * @return {}
 */
const reload = () : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<void> => {
    dispatch( {
        type: USER_RELOAD_PERMISSIONS
    } );

    const result = await xhr.post(
        `${BASE_URL}/api/user/reloadPermissions`,
        undefined,
        undefined,
        'global_non_masking',
        'userReloadPermission',
        dispatch
    );

    if ( result?.data?.success && result.data.user ) {
        dispatch( setUser( result.data.user ) );
    }
}

export type ReloadPermissions = typeof reload;

export default reload;
